$(document).ready ->
  STORY_FILE_LIMITS = $('#story_file_limits').val() && JSON.parse($('#story_file_limits').val())
  fileObject = {}
  croppie_story = ''
  tags_restricted_story = $('#tags_restricted').val() == 'true'
  story_images = {}

  $('.stories').sortable ->
    cursor: "move"

  $('.stories').on('sortstop', (event, ui) ->
    $(this).parents('form').submit()
  )

  $($('#story_name_language').parent()).click (event) ->
    for result in $('#story_name_language_chosen .chosen-results').children()
      text = $(result).text()
      key = $('#story_name_language').find('option:contains("'+text+'")').val()
      for id in $('input[id^="function_name_multi"]')
        if $(id).attr("id") == 'function_name_multi[' + key + ']'
          match = $(id).val()
          break
      if match.length > 0
        $(result).addClass("language-green")
        $(result).removeClass("language-orange")
      else
        $(result).addClass("language-orange")
        $(result).removeClass("language-green")

  $('#story_name_language').attr("data-prev", $('#story_name_language').val())

  $('#story_name_language').change (event) ->
    prev_language_id = $(event.target).attr("data-prev")
    current_language_id = $(event.target).val()
    $(event.target).attr("data-prev", current_language_id)
    $('#story-name-' + current_language_id).css("display", "block")
    $('#story-name-' + prev_language_id).css("display", "none")
    $('#story-image-' + current_language_id).css("display", "block")
    $('#story-image-' + prev_language_id).css("display", "none")

  $('.tags-custom-box').click (event) ->
    class_names = $(this).attr('class')
    tag = "#" + $(this).parent().attr('tags_id').toString()
    if class_names.indexOf('story-available-tag') != -1
      $(this).removeClass 'story-available-tag'
      $(this).addClass 'story-selected-tag'
      $(this).find('.tag-close').text 'x'
      $(this).parent().parent().find('.story-selected-tags').append $(this)
      $(tag).val $(tag).val().concat(',' + $(this).find('.tag-label').text())
    else if class_names.indexOf('story-selected-tag') != -1
      $(this).removeClass 'story-selected-tag'
      $(this).addClass 'story-available-tag'
      $(this).find('.tag-close').text '+'
      $(this).parent().parent().find('.story-available-tags').append $(this)
      tag_used = $(tag).val().split(',')
      match_index = tag_used.indexOf($(this).find('.tag-label').text())
      if match_index != -1
        tag_used.splice match_index, 1
        $(tag).val tag_used.join(',')
    return

  $('.add-story-tags').click (event) ->
    if $(event.target).attr("data_link").indexOf('country') >= 0
      $('.tag-close').css 'background', 'rgb(47, 156, 152) none repeat scroll 0 0'
      $('.tag-label').css 'background', 'rgba(47, 156, 152, 0.8) none repeat scroll 0 0'
    else if $(event.target).attr("data_link").indexOf('office') >= 0
      $('.tag-close').css 'background', 'rgb(65, 117, 5) none repeat scroll 0 0'
      $('.tag-label').css 'background', 'rgba(65, 117, 5, 0.8) none repeat scroll 0 0'
    else if $(event.target).attr("data_link").indexOf('role') >= 0
      $('.tag-close').css 'background', 'rgb(133, 46, 151) none repeat scroll 0 0'
      $('.tag-label').css 'background', 'rgba(133, 46, 151, 0.8) none repeat scroll 0 0'
    $($(event.target).attr("data_link")).openModal()
  
  $('.modal-for-story-tags').click (event) ->
    $('.tag-close').css("background", "none")
    $('.tag-label').css("background", "none")
    $($(event.target).attr("data_link")).openModal()
    
  $('.hide-select-tag-modal').click (event) ->
    $(event.target).parents().find('.popup-edit-cat').hide()
    
  $(".upload-story-image-file").change (event) ->
    file_preview = $(event.target).parents('.image-container').find(".upload-preview-story-image").find('img')
    $(this).parents('.image-container').find(".edit-story-image-modal").css("display", "inline-block")
    $(this).parents('.image-container').find(".edit-alt-text-story-image-modal").css("display", "inline-block")

    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    fileObject.filetype_image = file.type;
    fileObject.filename_image = file.name;
    language = $('#story_name_language').val();
    story_images[language] = {name: file.name, type: file.type}

    return if fileSizeNotInLimit(file,event,".edit-story-image-modal",STORY_FILE_LIMITS["image"])
    $(this).parents('.image-container').find('.remove-story-image').parent('.cs-trash').css("opacity", 1)
    $(this).parents('.image-container').find('.remove-story-image').parent('.cs-trash').css("pointer-events", "all")

    reader = new FileReader()
    reader.onload = (e) ->
      image_base64 = e.target.result
      file_preview.attr "src", image_base64
      return
    reader.readAsDataURL file
    return

  $('.remove-story-image').click (event) ->
    $($(event.target)[0]).parents('.image-container').find('.upload-preview-story-image').find('img').attr("src", null)
    $($(event.target)[0]).parents('.image-container').find(".edit-alt-text-story-image-modal").css("display", "none")
    $($(event.target)[0]).parents('.image-container').find(".edit-story-image-modal").css("display", "none")
    $(this).parent('.cs-trash').css("opacity", 0.5)
    $(this).parent('.cs-trash').css("pointer-events", "none")
    return
    
  $(".edit-story-image-modal").click (event) ->
    $("#image_modal").openModal();
    $("#image_modal").html('<div class="center-align"><i class="fa fa-spinner fa-spin fa-3x"></i></div>');

    cropbox = '#story_edit_image_cropbox'
    $(cropbox).attr "src", $($(event.target)[0]).siblings("img").attr("src")

    details = $(this).data('file-details').split(',')
    if !fileObject.filetype_image && details.length > 1
      fileObject.filetype_image = details[1].slice(1)
      fileObject.filename_image = details[0]
      language = $('#story_name_language').val();
      story_images[language] = {name: details[0], type: details[1].slice(1)}

    $(".upload-preview").removeClass "upload-preview"
    $($(event.target)[0]).parent().addClass "upload-preview"
    $('#editCropStoryImageModal').find(".upload-preview-story-image").addClass "upload-preview"

    croppie_story = $('.croppie').croppie({
      viewport: {
        width: 448,
        height: 322
      }
    });
    if $('#editCropStoryImageModal').find('.croppie-container').length > 1
      $('#editCropStoryImageModal').find('.croppie-container:last').appendTo('#editCropStoryImageModal .main-image-container')
      $('#editCropStoryImageModal').find('.croppie-container:first').remove()
    return

  $('.save-cropped-image-btn').click ->
    if croppie_story
      src = croppie_story.get(0).src
      format = croppie_story.get(0).src.split(';')[0].split('/')[1]
      if !format
        format = 'jpeg'
      croppie_story.croppie('result',
        type: 'canvas'
        size: 'original'
        format: format
        quality: '0.99'
      ).then (response) ->
        $('.upload-preview img').attr('src', response)

  $('#edit_story').submit (e) ->
    e.preventDefault()
    $('#loading-modal').openModal({dismissible: false})

    index = 0
    $(e.target).children().find(".story-image-uploaded").each ->
      language_id = $($(e.target).children().find(".story-image-uploaded")[index]).data('language-id').toString()
      story_images[language_id] = {} if story_images[language_id] == undefined
      if $($(e.target).children().find(".story-image-uploaded")[index]).find("img").attr('src') != undefined && $($(e.target).children().find(".story-image-uploaded")[index]).find("img").attr('src').indexOf("base64") != -1
        story_images[language_id]['content'] = $($(e.target).children().find(".story-image-uploaded")[index]).find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
      else if $($(e.target).children().find(".story-image-uploaded")[index]).find("img").attr('src') == undefined
        story_images[language_id]['content'] = 'null'
      index++

    name_multi = {}
    for name in $('input[id^="function_name_multi"]')
      id = $(name).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      val = $(name).val()
      name_multi[key] = val

    alt_text_for_story_images = {}
    for alt_text in $('input[id^="story_image_alt_text"]')
      id = $(alt_text).attr("id")
      key = id.split("_").pop()
      val = $(alt_text).val()
      alt_text_for_story_images[key] = val

    asset_id_for_story_images = {}
    for asset_id in $('input[id^="asset-id-story-image"]')
      id  = $(asset_id).attr("id")
      key = id.split("-").pop()
      val = $(asset_id).val()
      asset_id_for_story_images[key] = val

    $.ajax(
      type: 'POST',
      url: "#{$(this).attr('action')}.json"
      enctype: 'multipart/form-data',
      dataType: 'json',
      data:
        'story[alt_text_for_story_images]': alt_text_for_story_images
        'story[custom_images]': story_images
        'story[asset_id_for_images]': asset_id_for_story_images
        'story[runtime]': $("#story_runtime").val()
        'story[status]': $("#story_status").val()
        'function[name]': $(e.target).children().find('#function_name').val()
        'function[name_multi]': name_multi
        'select_country_tags': $(e.target).find('#select_country_tags').val()
        'select_office_tags': $(e.target).find('#select_office_tags').val()
        'select_role_tags': $(e.target).find('#select_role_tags').val()
        'authenticity_token': $('input[name=authenticity_token]').val()
        '_method': 'patch'
    ).done((data, textStatus, jqXHR) ->
      window.location.href = data["redirect_to"]
      return
    ).fail((jqXHR, textStatus, errorThrown) ->
      $(e.target).find("input[type='submit']").attr("disabled",false)
      $(e.target).find("input[type = 'submit']").val("Update")
      $('#loading-modal').closeModal()
      alert (jqXHR.responseText)
      return
    )
    true

  $('#new_story').submit (e) ->
    e.preventDefault()
    story_image           = ''
    story_runtime         = ''
    asset_id              = $(e.target).children().find("#asset-id-story-image-with-out-tag").val() || $(e.target).children().find("#asset-id-story-image-with-tag").val()
    asset_library_allowed = $(e.target).children().find("#asset_library_allowed").val()
    
    unless $(e.target).children().find(".story-image-uploaded").find("img").attr('src') == undefined
      if asset_library_allowed == 'false'
        story_image = $(e.target).children().find(".story-image-uploaded").find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
      else
        story_image = ''

    $.ajax(
      type: 'POST',
      url: "#{$(this).attr('action')}.json"
      enctype: 'multipart/form-data',
      data:
        'authenticity_token': $('input[name=authenticity_token]').val()
        'story[image_alt_text]': $(e.target).children().find('#new_story_image_alt_text').val()
        'story[custom_image][base64]': story_image
        'story[custom_image][filetype]': fileObject.filetype_image
        'story[custom_image][filename]': fileObject.filename_image
        'function[story][runtime]': $("#function_story_runtime").val()
        'function[story][status]': $("#function_story_status").val()
        'function[name]': $(e.target).children().find('#function_name').val()
        'function[function_type]': $(e.target).children().find('#function_function_type').val()
        'function[course_id]': $(e.target).children().find('#function_course_id').val()
        'select_country_tags': $(e.target).children().find('#select_country_tags').val()
        'select_office_tags': $(e.target).children().find('#select_office_tags').val()
        'select_role_tags': $(e.target).children().find('#select_role_tags').val()
        'story[asset_id_for_images]': asset_id
    ).done((data, textStatus, jqXHR) ->
      window.location.href = data["redirect_to"]
      return
    ).fail((jqXHR, textStatus, errorThrown) ->
      alert (jqXHR.responseText)
      return
    )
    true
    
  $('#new_story_with_tags').submit (e) ->
    e.preventDefault()
    story_image           = ''
    story_runtime         = ''
    asset_id              = $(e.target).children().find("#asset-id-story-image-with-out-tag").val() || $(e.target).children().find("#asset-id-story-image-with-tag").val()
    asset_library_allowed = $(e.target).children().find("#asset_library_allowed").val()
    
    if tags_restricted_story && !!!$('#tags_country_tags').val() && !!!$('#tags_office_tags').val() && !!!$('#tags_role_tags').val()
      alert "Story needs to have at least one of your assigned tags"
      return

    unless $(e.target).children().find(".story-image-uploaded").find("img").attr('src') == undefined
      if asset_library_allowed == 'false'
        story_image = $(e.target).children().find(".story-image-uploaded").find("img").attr('src').replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, "")
      else
        story_image = ''

    $.ajax(
      type: 'POST',
      url: "#{$(this).attr('action')}.json"
      enctype: 'multipart/form-data',
      data:
        'authenticity_token': $('input[name=authenticity_token]').val()
        'story[custom_image][base64]': story_image
        'story[custom_image][filetype]': fileObject.filetype_image
        'story[custom_image][filename]': fileObject.filename_image
        'function[story][runtime]': $("#function_story_runtime").val()
        'function[story][status]': $("#function_story_status").val()
        'function[name]': $(e.target).children().find('#function_name').val()
        'function[function_type]': $(e.target).children().find('#function_function_type').val()
        'function[course_id]': $(e.target).children().find('#function_course_id').val()
        'function[country_tags]': $("#tags_country_tags").val()
        'function[office_tags]': $("#tags_office_tags").val()
        'function[role_tags]': $("#tags_role_tags").val()
        'story[asset_id_for_images]': asset_id
    ).done((data, textStatus, jqXHR) ->
      window.location.href = data["redirect_to"]
      return
    ).fail((jqXHR, textStatus, errorThrown) ->
      alert (jqXHR.responseText)
      return
    )
    true

  $('#toggle-story-filters-CHANGED').click (e) ->
    if $(this).parents('.search-rightside-panel').css('width') != '45px'
      $(this).parents('.search-rightside-panel').css('width', '45px')
    else
      $(this).parents('.search-rightside-panel').css('width', '410px')

  delay = do ->
    timer = 0
    (callback, ms) ->
      clearTimeout timer
      timer = setTimeout(callback, ms)
      return

  $('.tags_multiple_select').multiSelect null, (el) ->
    $('#callbackResult').show().fadeOut()
    return

  $(".search-tag-dropdowns-CHANGED label").click (event) ->
    contextual_content_filter = $('.contextual-content-filter')
    country_tag = []
    for tag in ($('#select_country_tags').parent().find('.multiSelectOptions').find('.checked'))
      country_tag.push($(tag).find("input").val())

    office_tag = []
    for tag in ($('#select_office_tags').parent().find('.multiSelectOptions').find('.checked'))
      office_tag.push($(tag).find("input").val())
    
    role_tag = []
    for tag in ($('#select_role_tags').parent().find('.multiSelectOptions').find('.checked'))
      role_tag.push($(tag).find("input").val())
    
    country_tags = []
    office_tags = []
    role_tags = []
    
    if $('#hide_tags').is(':checked')
      hide_tags = true
    else
      hide_tags = false
 
    if (country_tag.length == 0) && (office_tag.length == 0) && (role_tag.length == 0)
      for contextual_content in contextual_content_filter
        if hide_tags
          country_tags = $(contextual_content).attr("country_tags").split(",")
          office_tags = $(contextual_content).attr("office_tags").split(",")
          role_tags = $(contextual_content).attr("role_tags").split(",")
          if (country_tags[0] == "" && office_tags[0] == "" && role_tags[0] == "")
            $(contextual_content).css("display", "none")
          else
            $(contextual_content).css("display", "")
        else
          $(contextual_content).css("display", "")
    else
      for contextual_content in contextual_content_filter
        country_tags = $(contextual_content).attr("country_tags").split(",")
        office_tags = $(contextual_content).attr("office_tags").split(",")
        role_tags = $(contextual_content).attr("role_tags").split(",")
        if hide_tags && (country_tags[0] == "" && office_tags[0] == "" && role_tags[0] == "")
          match_index = -1
        else if country_tag.length > 0
          if country_tags[0] != ""
            if compare_arrays(country_tags, country_tag) == 0
              match_index = 0
            else
              match_index = -1
          else
            match_index = 0
          if match_index != -1 && office_tag.length > 0 && office_tags[0] != ""
            if compare_arrays(office_tags, office_tag) == 0
              match_index = 0
            else
              match_index = -1
          else if match_index != -1 && office_tags[0] == ""
            match_index = 0
          if match_index != -1 && role_tag.length > 0 && role_tags[0] != ""
            if compare_arrays(role_tags, role_tag) == 0
              match_index = 0
            else
              match_index = -1
          else if match_index != -1 && role_tags[0] == ""
            match_index = 0
        else if office_tag.length > 0
          if office_tags[0] != ""
            if compare_arrays(office_tags, office_tag) == 0
              match_index = 0
            else
              match_index = -1
          else
            match_index = 0
          if match_index != -1 && role_tag.length > 0 && role_tags[0] != ""
            if compare_arrays(role_tags, role_tag) == 0
              match_index = 0
            else
              match_index = -1
          else if match_index != -1 && role_tags[0] == ""
            match_index = 0
        else if role_tag.length > 0
          if role_tags[0] != ""
            if compare_arrays(role_tags, role_tag) == 0
              match_index = 0
            else
              match_index = -1
          else if match_index != -1 && role_tags[0] == ""
            match_index = 0
        if match_index != -1
          $(contextual_content).css("display", "")
        else
          $(contextual_content).css("display", "none")
          
  $('#hide_tags').click (event) ->
    contextual_content_filter = $('.contextual-content-filter')
    if $('#hide_tags').is(':checked')
      display = "none"
    else
      display = ""
    for contextual_content in contextual_content_filter
      country_tags = $(contextual_content).attr("country_tags").split(",")
      office_tags = $(contextual_content).attr("office_tags").split(",")
      role_tags = $(contextual_content).attr("role_tags").split(",")
      if (country_tags[0] == "" && office_tags[0] == "" && role_tags[0] == "")
        $(contextual_content).css("display", display)

  compare_arrays = (a1, a2) ->
    for i in a1
      for j in a2
        if i == j
          return 0
    return -1
